// Packages:
import styled from 'styled-components'
import { Handle } from 'react-flow-renderer'


// Exports:
export const TicketNodeWrapper = styled.div`
  position: relative;
  min-width: 12.5rem;
  max-width: 20rem;
  background-color: #FEFFFE;
  border: 2px solid #235789;
  border-radius: 0.25rem;
  box-shadow: 0px 5px 20px -10px dimgrey;
  cursor: pointer;
  transition: all 0.25s ease;

  &:active {
    cursor: grabbing;
  }
`

export const TicketNodeLabel = styled.div`
  width: 100%;
  padding: 0rem 2.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.15rem;
  color: #333533;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
  transition: all 0.25s ease;
`

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0.75rem;
  padding-bottom: 0.75rem;
  align-items: center;
`

export const Description = styled.div`
  display: flex;
  align-items: center;
  margin: 0.2rem 0.25rem;
  font-weight: 500;
  font-size: 0.8rem;
`

export const Field = styled.span`
  width: max-content;
  min-width: 6rem;
  margin: 0 0.2rem;
  padding: 0.1rem 0.2rem;
  padding-right: 0.3rem;
  background: ${ props => props.isActive ? '#112E49' : '#235789' };
  font-weight: 600;
  color: white;
  border-radius: 3px;
`

export const StyledHandle = styled(Handle)`
  z-index: 2;
  width: 0.75rem;
  height: 0.75rem;
  background-color: #0B7A75;
  border: none;
`
